import React from 'react';
import { useNavigate } from 'react-router-dom';
import ReactMarkdown from 'react-markdown';

/**
 * Layout compartido para páginas legales públicas (Términos, Privacidad).
 * Sin auth requerido. Markdown clásico con tipografía legible.
 */
export default function LegalPage({ title, lastUpdated, content, testId }) {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-slate-900 text-slate-100" data-testid={testId}>
      {/* Topbar mínima */}
      <header className="border-b border-white/5 bg-slate-900/80 backdrop-blur">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 py-4 flex items-center justify-between">
          <button
            onClick={() => navigate('/')}
            className="text-sm font-semibold tracking-wide text-white hover:text-[#5B9B2F] transition-colors"
            data-testid="legal-back-home"
          >
            EVALPRO
          </button>
          <button
            onClick={() => navigate('/')}
            className="text-xs text-slate-400 hover:text-white transition-colors"
            data-testid="legal-back-link"
          >
            ← Volver al inicio
          </button>
        </div>
      </header>

      {/* Contenido legal */}
      <main className="max-w-3xl mx-auto px-4 sm:px-6 py-10 sm:py-14">
        <h1 className="text-2xl sm:text-3xl font-bold text-white mb-2 font-['Inter']" data-testid="legal-title">
          {title}
        </h1>
        <p className="text-sm text-slate-400 mb-8 italic font-['Inter']">{lastUpdated}</p>

        <article
          className="
            prose prose-invert prose-sm sm:prose-base max-w-none
            prose-headings:font-['Inter'] prose-headings:text-white
            prose-h2:text-xl prose-h2:mt-10 prose-h2:mb-3 prose-h2:font-semibold
            prose-h3:text-lg prose-h3:mt-6 prose-h3:mb-2
            prose-p:text-slate-200 prose-p:leading-relaxed prose-p:my-3
            prose-strong:text-white
            prose-li:text-slate-200 prose-li:my-1
            prose-a:text-[#5B9B2F] prose-a:no-underline hover:prose-a:underline
            prose-hr:border-white/10
          "
          data-testid="legal-content"
        >
          <ReactMarkdown>{content}</ReactMarkdown>
        </article>

        {/* Footer simple */}
        <footer className="mt-14 pt-6 border-t border-white/5 text-xs text-slate-500 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p>© {new Date().getFullYear()} EVALPRO · Todos los derechos reservados</p>
          <div className="flex items-center gap-4">
            <button
              onClick={() => navigate('/terminos')}
              className="hover:text-white transition-colors"
              data-testid="legal-footer-terms"
            >
              Términos y Condiciones
            </button>
            <span>·</span>
            <button
              onClick={() => navigate('/privacidad')}
              className="hover:text-white transition-colors"
              data-testid="legal-footer-privacy"
            >
              Política de Privacidad
            </button>
          </div>
        </footer>
      </main>
    </div>
  );
}
